import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SCircle from '@/assets/logo/SCircle.svg?react';
import Swipesign from '@/assets/logo/Swipesign.svg?react';
import Languages from './Languages';
import styles from './LoginHeader.module.scss';

const LoginHeader = () => {
  const route = useLocation();
  const { t } = useTranslation('common');

  const link = route.pathname.startsWith('/auth/login')
    ? {
        label: t('loginHeader.Register'),
        href: '/auth/register',
      }
    : {
        label: t('loginHeader.Login'),
        href: '/auth/login',
      };

  return (
    <header className={styles.header}>
      <Link to="/" className={styles.home}>
        <SCircle className={styles.s} />
        <Swipesign className={styles.logo} />
      </Link>
      <Link to={link.href} className={styles.link}>
        {link.label}
      </Link>
      <Languages />
    </header>
  );
};

export default LoginHeader;
